import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {COMMISSION_SETTLEMENT_STATUS_NEW} from "../../../shared/services/dict.service";
import {CommissionSettlementService} from "../../../shared/services/commission-settlement.service";
import {JobService} from "../../../shared/services/job.service";
import {Job} from "../../../shared/interface/job";
import {interval, ReplaySubject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {ThemePalette} from "@angular/material/core";
import {ProgressBarMode} from "@angular/material/progress-bar";

export interface JobListDialogData {
  commissionSettlementService: any;
  billingMonth: string;
  checkSettlement?: boolean;
  checkSettlementButton?: boolean;
  partner: string;
  ofwca: string;

}
@Component({
  selector: 'app-jobs-list-dialog',
  templateUrl: './jobs-list-dialog.component.html',
  styleUrls: ['./jobs-list-dialog.component.scss']
})
export class JobsListDialogComponent implements OnInit, OnDestroy {

  // commissionSettlementService: any = {};
  billingMonth: any;
  partner = '';
  ofwca = '';
  checkSettlement = false;
  checkSettlementButton = false;
  job = false;
  jobId: string;
  showProgress: boolean;
  commissionImportRowIncorrect: any;
  settlementsToGenerate: any;
  closed = true;
  jobObject: Job;
  jobRun = false;
  showErrors = false;
  runClosed = false;
  displayedColumns: string[] = ['result'];
  color: ThemePalette = 'accent';
  mode: ProgressBarMode = 'indeterminate';
  readonly COMMISSION_SETTLEMENT_STATUS_NEW = COMMISSION_SETTLEMENT_STATUS_NEW;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    public dialogRef: MatDialogRef<JobsListDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: JobListDialogData,
    private commissionSettlementService: CommissionSettlementService,
    private jobService: JobService

  ) {
    // this.commissionSettlementService = data.commissionSettlementService;
    this.billingMonth = data.billingMonth;
    this.partner = data.partner;
    this.ofwca = data.ofwca;
    this.checkSettlement = data.checkSettlement ?? this.checkSettlement;
    this.checkSettlementButton = data.checkSettlementButton ?? this.checkSettlementButton;

  }

  ngOnInit(): void {
    if (!this.checkSettlement && !this.checkSettlementButton) {
      this.commissionSettlementService.hasClosedSettlements(
        this.billingMonth.format('YYYY-MM'), {partner: this.partner, ofwca: this.ofwca}
      ).subscribe((job) => {
        this.runClosed = true;
        const run = interval(1000)
          .pipe(takeUntil(this.destroyed$))
          .subscribe((r) => {
            this.jobService.getJob(job.uuid)
              .pipe().subscribe((response) => {
              this.jobObject = response;
              this.job = true;
              if (response.exitCode){
                this.jobRun = true;
                run.unsubscribe();
                response.parameters.forEach((item) => {
                  if (item?.checkClosed){
                      this.closeDialogRef();
                  } else {
                    this.showErrors = true;
                  }
                });
              }
            });
          });
      });
    } else {
      this.commissionSettlementService.checkCommissionContractSettlement(
        this.billingMonth.format('YYYY-MM'), {partner: this.partner, ofwca: this.ofwca}
      ).subscribe((job) => {
        const run = interval(1000)
          .pipe(takeUntil(this.destroyed$))
          .subscribe((r) => {
            this.jobService.getJob(job.uuid)
              .pipe().subscribe((response) => {
                this.jobObject = response;
                this.job = true;
                if (response.exitCode){
                  let settlementCount: number;
                  let settlementContractTypCount: number;
                  let settlementContractCount: number;
                  this.jobRun = true;
                  run.unsubscribe();
                  response.parameters.forEach((item) => {
                    settlementCount = item.settlementCount ;
                    settlementContractTypCount = item.settlementContractTypCount ;
                    settlementContractCount = item.settlementContractCount ;
                  });
                  if (settlementCount === 0 && settlementContractTypCount === 0 && settlementContractCount === 0 && this.checkSettlementButton) {
                    this.closeDialogRef();
                  }
                }
            });
          });
      });
    }
  }
  closeDialogRef(): void{
    this.dialogRef.close(true);
  }

  decline(): void {
    this.dialogRef.close(false);
  }

  trackTask(index: number, job: Job): string {
    return job.uuid;
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

}
